/**
 * NIS2-aligned password policy (ENISA / strict IAM best practices).
 * - Minimum length 12 characters
 * - At least one uppercase, one lowercase, one digit, one special character
 */

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;

const HAS_UPPERCASE = /[A-Z]/;
const HAS_LOWERCASE = /[a-z]/;
const HAS_DIGIT = /[0-9]/;
const HAS_SPECIAL = /[^A-Za-z0-9]/;

/**
 * Validates password against NIS2-style policy.
 * @param {string} password
 * @returns {{ valid: boolean, errors: string[] }}
 */
export function validatePassword(password) {
	const errors = [];
	if (!password || password.length < PASSWORD_MIN_LENGTH) {
		errors.push('Legalább ' + PASSWORD_MIN_LENGTH + ' karakter hosszú legyen.');
	}
	if (password.length > PASSWORD_MAX_LENGTH) {
		errors.push('Legfeljebb ' + PASSWORD_MAX_LENGTH + ' karakter lehet.');
	}
	if (!HAS_UPPERCASE.test(password)) {
		errors.push('Tartalmazzon nagybetűt (A–Z).');
	}
	if (!HAS_LOWERCASE.test(password)) {
		errors.push('Tartalmazzon kisbetűt (a–z).');
	}
	if (!HAS_DIGIT.test(password)) {
		errors.push('Tartalmazzon számjegyet (0–9).');
	}
	if (!HAS_SPECIAL.test(password)) {
		errors.push('Tartalmazzon speciális karaktert (pl. !@#$%^&*).');
	}
	return {
		valid: errors.length === 0,
		errors
	};
}

/** User-facing list of requirements for UI (NIS2 kompatibilis). */
export const PASSWORD_REQUIREMENTS_TEXT = [
	'Legalább ' + PASSWORD_MIN_LENGTH + ' karakter',
	'Nagybetű (A–Z)',
	'Kisbetű (a–z)',
	'Számjegy (0–9)',
	'Speciális karakter (pl. ! @ # $ % ^ & *)'
];
